import { wizardStepType } from "../../type"
const getClassName = (current: wizardStepType, type: wizardStepType) => {
  return current > type ? "active" : current === type ? "active" : ""
}
const WizardStep = (props: any) => {
  const { currentStep } = props
  return (<ul className="wizard-count-list">
    <li className={getClassName(currentStep, wizardStepType.BrowserFile)} >
      <span>1</span>
      <p>Browse File</p>
    </li>
    <li className={getClassName(currentStep, wizardStepType.FunctionMap)}>
      <span>2</span>
      <p>Function Mapping</p>
    </li>
  </ul>)
}
export { WizardStep }